import AuthAccess from "src/data/auth/authAccess/AuthAccess";
import AddrPerson from "./AddrPerson";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useUserData } from "src/context/userContext";
import { person_fetch_by_id } from "src/data/person/PersonFunctions";
import ProgressCirc from "src/components/layout/Progress/ProgressCirc";

export default function AddrPersonCore() {
  const [person, setPerson] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { token, ownerAsiakasId } = useUserData();

  let params = useParams();
  let personId = params.personId;
  if (personId !== undefined) personId = Number(personId);
  if (personId !== undefined && isNaN(personId)) personId = 0;

  useEffect(() => {
    const asyncFunc = async () => {
      // props given, so we are in "show person" mode
      const _person = await person_fetch_by_id(personId, token);
      setPerson(_person);
      setIsLoading(false);
    };
    asyncFunc();
  }, [personId, ownerAsiakasId]);

  if (isLoading) return <ProgressCirc />;

  return (
    <AuthAccess person={person} showError>
      <AddrPerson person={person} />
    </AuthAccess>
  );
}
